import React from "react";
import { formatMetric, mirrorShare } from "./fiData";
import "./fi-extra.css";

/**
 * Rows of "A value | bar | B value". Each bar shows A's share of the pair's
 * combined value, a layout aid only (lower is not "worse" for every metric,
 * so nothing is coloured good or bad).
 *
 * rows: [{ key, label, a, b, na?, nb? }]  (na/nb are optional sample sizes)
 * mean: format every value with two decimals (for match means)
 */
export default function MirroredBars({ rows, nameA, nameB, mean = false }) {
  if (!rows.length) return null;
  return (
    <div className="fx-bars">
      {rows.map(({ key, label, a, b, na, nb }) => {
        const share = mirrorShare(a, b);
        const samples = na !== undefined || nb !== undefined ? ` · n ${na ?? 0} / ${nb ?? 0}` : "";
        return (
          <div className="fx-bar-row" key={key}>
            <div className="fx-bar-label">{label}{samples}</div>
            <span className="fx-val a">{formatMetric(key, a, mean)}</span>
            <div
              className={`fx-bar ${share === null ? "empty" : ""}`}
              role="img"
              aria-label={
                share === null
                  ? `${label}: comparison unavailable`
                  : `${label}: ${nameA} ${formatMetric(key, a, mean)}, ${nameB} ${formatMetric(key, b, mean)}`
              }
            >
              {share !== null && (
                <>
                  <i className="a" style={{ width: `${share * 100}%` }} />
                  <i className="b" style={{ width: `${(1 - share) * 100}%` }} />
                </>
              )}
            </div>
            <span className="fx-val">{formatMetric(key, b, mean)}</span>
          </div>
        );
      })}
    </div>
  );
}
